const linkBaseUrl = `${window.location.protocol}//${window.location.host}`;
const baseUrl = 'https://lotsmall.51dmq.com/';
const qyyxUrl = 'https://qyyxwap.lotsmall.cn';
export {
  linkBaseUrl,
  baseUrl,
  qyyxUrl,
};
